import React from 'react';
import Downloadimg01 from '../../assets/images/black_google_play.webp';
import Downloadimg02 from '../../assets/images/black_appstore.webp';
import Downloadimg03 from '../../assets/images/our_app.webp';
import PlayStoreLink from '../Global/PlayStoreLink';
import AppStoreLink from '../Global/AppStoreLink';
import { siteCopy } from '../../content/siteCopy';

const AppDownload = () => {
  return (
    <>
  <section className="row_am download_app" id="download_sec">
    <div className="task_block" data-aos="fade-up" data-aos-duration={1500}>
      <div className="row">
        <div className="col-md-6">
          <div className="task_text">
            <div
              className="section_title white_text"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              <span className="title_badge">Download</span>
              <h2>Take your next small step today</h2>
              <p>{siteCopy.promo}</p>
            </div>
            <ul className="app_btn" data-aos="fade-up" data-aos-duration={1500}>
              <li>
                <PlayStoreLink>
                  <img className="blue_img" src={Downloadimg01} alt="Get it on Google Play" />
                </PlayStoreLink>
              </li>
              <li>
                <AppStoreLink>
                  <img className="blue_img" src={Downloadimg02} alt="Download on the App Store" />
                </AppStoreLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
            <div className="frame_img">
              <img src={Downloadimg03} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>
  )
}

export default AppDownload
